import { BACKEND_API_PLACEHOLDER } from "@/../environment.config";
import { fetchCurrentUserData } from "@/util/customFetch";

// sample data imports for offline dev purposes
const isOfflineDev = import.meta.env.VITE_OFFLINE_DEV === "true";
const {imagesSuccess} = isOfflineDev ? await import("../tests/fixtures/Images.js") : {};

export async function linkImageToSource(postRequest, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + '/api/v1/images/new', {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({postRequest})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getImagesBySource(id, headers) {
  if (!isOfflineDev) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
    return fetch(BACKEND_API_PLACEHOLDER + `/api/v1/images/source?source_id=${id}`, {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
    )
  }
  else return imagesSuccess
}

export async function getImagesBySources(arr, headers) {
  if (!isOfflineDev) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + '/api/v1/images/sources'
  for (let i = 0; i < arr.length; i++) {
    url += `${i > 0 ? '&' : '?'}source_id=${arr[i]}`
  }
    return fetch(url, {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
    )
  }
  else return imagesSuccess
}

export async function deleteImage(id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/v1/images/delete?id=${id}`, {
    method: 'DELETE',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function updateImage(id, postRequest, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/v1/images/edit/id?id=${id}`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify({ postRequest }),
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}